<template>
<div>
    <v-row>
        <template v-for="product in products">
            <v-col cols="6" sm="4" md="3" :key="product._id">
                <slot name="list-item" :product="product" />
            </v-col>
        </template>
    </v-row>

    <div class="mt-30px mt-md-40px">
        <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="$emit('input', page)" />
    </div>
</div>
</template>
<script>
export default {
    props: {
        value: { type: Number, default: 1 },
        pageCount: { type: Number, default: 0 },
        limit: { type: Number, default: 10 },
        products: { type: Array, default: [] }
    },
    data(){
        return {
            page: this.$props.value || 1,
        }
    }
}
</script>